module.exports = __webpack_public_path__ + "static/img/back06.aaf517e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/back06.png
// module id = G1vO
// module chunks = 1